import React, { Component } from 'react';
import CustomModal from '../../shared/CustomModal';
import CreateMappedUserContainer from './CreateMappedUser';
import MappedUserDetailsContainer from './MappedUserDetails';

class MappedUserModal extends Component {
    constructor(props) {
            super(props);
            this.state = {
                showNewUserModal: false,
                showUserDetailsModal: false,
                email: '',
                fromDashboard: props.fromDashboard,
                userCreated: false
            }
        }
      
       componentDidMount() {
            if (this.props.fromDashboard) {
                this.toggleNewUserModal();
            }
        }
    
        /**
         * @description Funtion to toggle new user modal
         * @memberof AddUserModalComponent
         */
        toggleNewUserModal = () => {
            this.setState(prevState => {
                return { showNewUserModal: !prevState.showNewUserModal }
            });
        }
    
        /**
         * @description Funtion to toggle user details modal
         * @memberof AddUserModalComponent
         */
        toggleUserDetailsModal = (email, userCreated = false) => {
            this.setState(prevState => {
                return { email: email, showUserDetailsModal: !prevState.showUserDetailsModal, userCreated }
            });
        }
    
        /**
         * @description Funtion to explicitly close new user modal
         * @memberof AddUserModalComponent
         */
        closeNewUserModal = () => {
            this.setState({ showNewUserModal: false })
        }
    
        /**
         * @description Funtion to explicitly close user details modal
         * @memberof AddUserModalComponent
         */
        closeUserDetailsModal = () => {
            this.setState({ showUserDetailsModal: false })
        }
    
        /**
         * @description Funtion to handle situation when user added
         * @memberof AddUserModalComponent
         */
        userAdded = (email) => {
            this.closeNewUserModal();
            setTimeout(() => {
                this.toggleUserDetailsModal(email, true);
                this.props.mappedUserUpdated(true, email);
            }, 0);
        }
    
        render() {
            const { showNewUserModal, showUserDetailsModal, email, userCreated } = this.state;
            const { mappedUserUpdated } = this.props;
            return (
                <>
                    <button type="button" data-testid="addUserBtn" id="addUserBtn" className="btn btn-primary mt-3" onClick={(e) => { e.preventDefault(); this.toggleNewUserModal(); }}>Add New</button>
                    {/* Modal to add new user */}
                    <CustomModal
                        id="add-mapped-user-modal"
                        show={showNewUserModal}
                        title="Add New S+N User"
                        isComponent={true}
                        dialogClassName="map-user-details-dialog"
                        closeAction={this.closeNewUserModal}>
                        <CreateMappedUserContainer data-testid="addUserBtn" id="add-user-container" handleCancel={this.closeNewUserModal} userAdded={this.userAdded} />
                    </CustomModal>
    
                    {/* Modal to show user details */}
                    <CustomModal
                        id="mapped-user-details-modal"
                        show={showUserDetailsModal}
                        title="S+N User Details"
                        isComponent={true}
                        dialogClassName="mapped-user-details-dialog"
                        closeAction={this.closeUserDetailsModal}>
                        <MappedUserDetailsContainer
                            email={email}
                            userCreated={userCreated}
                            mappedUserUpdated={mappedUserUpdated}
                            handleCancel={this.closeUserDetailsModal}
                        />
                    </CustomModal>
                </>
            );
        }
}

export default MappedUserModal;
